import { FC, useState, useEffect } from "react";
import { Table, } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useVrmMaintenanceDetailsModel } from "../vrmBillMaintenanceRoModel";
import { RouterParamType } from "@/model/navModel";
import { ReturnMaintainMaterialList } from "../vrmBillMaintenanceRoType";
import zeng from "@/assets/images/zeng.png"

export const MaterialTableBox: FC<RouterParamType> = () => {
    const { detailMaterialList } = useVrmMaintenanceDetailsModel();
    const [totalPrice, setTotalPrice] = useState<string>("0");

    const title = <>
        <span>维修用料</span>
        <span style={{ marginLeft: '50px', fontSize: '14px' }}>
            总金额&nbsp;¥&nbsp;<span style={{ color: 'red', fontSize: '18px' }}>{totalPrice}</span>
            &nbsp;元&nbsp;({detailMaterialList.length}项){" "}
        </span>
    </>

    //计算总价
    useEffect(() => {
        let num: number = 0
        detailMaterialList.forEach((item) => {
            num += Number(item.receivableAmount)
        })
        setTotalPrice(num.toFixed(2));
    }, [detailMaterialList])

    const MaterialColumns: ColumnsType<ReturnMaintainMaterialList> = [
        {
            title: '序号',
            width: 40,
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        },
        {
            title: "商品编号",
            align: "center",
            width: 200,
            dataIndex: "materialCode",
        },
        {
            title: "商品名称",
            align: "center",
            width: 200,
            dataIndex: "materialName",
        },
        {
            title: "领料单号",
            align: "center",
            width: 120,
            dataIndex: "maintainOrderCode",
        },
        // {
        //     title: "品牌",
        //     align: "center",
        //     width: 80,
        //     dataIndex: "brandName",
        // },
        {
            title: "单位",
            align: "center",
            width: 80,
            dataIndex: "unitName",
        },
        // {
        //     title: "可用数量",
        //     align: "center",
        //     width: 80,
        //     dataIndex: "availableUseNum",
        // },
        {
            title: "已选数量",
            align: "center",
            width: 80,
            dataIndex: "materialNumber",
        },
        {
            title: "单价",
            align: "center",
            width: 80,
            dataIndex: "unitPrice",
        },
        {
            title: "总计",
            align: "center",
            width: 80,
            dataIndex: "materialAmount",
        },
        {
            title: "优惠",
            align: "center",
            width: 80,
            dataIndex: "preferentialAmount",
        },
        {
            title: "折扣",
            align: "center",
            width: 80,
            dataIndex: "materialDiscount",
        },
        {
            title: "总金额",
            align: "center",
            width: 80,
            dataIndex: "receivableAmount",
        },
        {
            title: "是否赠送",
            align: "center",
            width: 100,
            dataIndex: "giftFlag",
            render: (text) => (text === "gift" ? <img src={zeng} style={{ width: "35px" }} alt="" /> : ""),
        },
        {
            title: "备注",
            align: "center",
            width: 200,
            dataIndex: "remark",
        }
    ];


    return (
        <YhBox title={title} style={{ marginBottom: "5px" }}>
            <Table
                rowKey={record => record.id as string}
                columns={MaterialColumns}
                dataSource={detailMaterialList}
                pagination={false}
                scroll={{ x: 'max-content', y: 300 }}
            />
        </YhBox>
    )
}